const BASE = process.env.REACT_APP_API || 'https://api.sharpwithit.vip';

async function request(method, path, body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : {},
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) { window.location.href = '/login'; return; }
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `Request failed: ${res.status}`);
  }
  return res.json();
}

export const api = {
  get:    (path)        => request('GET',    `/api${path}`),
  post:   (path, body)  => request('POST',   `/api${path}`, body),
  patch:  (path, body)  => request('PATCH',  `/api${path}`, body),
  delete: (path)        => request('DELETE', `/api${path}`),
};
